import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import { getHost } from '@utils/api-helper/host';
import useMyInfo from '../auth/useMyInfo';

const defaultHost = getHost();

const useGetRewardDetails = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = isLoggedIn
    ? `${defaultHost}v1/subscriptions/referrals/rewards`
    : null;

  const { data = {}, ...rest } = useFetch(key, { useCamelCase: true });
  return { data, ...rest };
};

export default useGetRewardDetails;
